import Waypoint from 'exports-loader?Waypoint!waypoints/lib/noframework.waypoints.min';
import $ from 'jquery';

$(() => {
    if (window.location.pathname === '/') {
        let $header = $('[id="header"]');
        let liElements = $header.find('li');
        let $window = $(window);

        $('[data-anchor]').each(function (i, el) {
            new Waypoint({
                element: el,
                handler () {
                    liElements.removeClass('active');

                    let anchor = this.element.getAttribute('data-anchor');
                    let element = liElements.find('[href$="#' + anchor + '"]');

                    if (element.length) {
                        element.closest('li').addClass('active');
                    }
                },
                offset () {
                    let $element = $(this.element);

                    if ($element.is('#bottom')) {
                        return $window.height() - $element.outerHeight();
                    }

                    if ($element.is('.banner')) {
                        return 0;
                    }

                    return $header.height();
                }
            });
        });

        setTimeout(() => { Waypoint.refreshAll(); }, 1500);
    }
});


// WEBPACK FOOTER //
// ./assets/app/js/menu/current.js